var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0mwl{fill:#588443;}\r\n\t.st1mwl{fill:#38281D;}\r\n\t.st2mwl{fill:#875439;}\r\n\t.st3mwl{fill:#8F604D;}\r\n\t.st4mwl{fill:#4C3424;}\r\n\t.st5mwl{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0mwl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1mwl",
    d: "M59.3,190.8c1.2,24.7,2.4,49.3,3.6,74c58.6,0,117.3,0,175.9,0c2.4-27.3,4.8-54.5,7.2-81.8 C183.8,185.6,121.5,188.2,59.3,190.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2mwl",
    d: "M89.2,80.6c-11,24.7-22,49.4-33,74.1c-2,7.1-7.4,29.5,4.7,43.2c0.9,1,1.9,2,3.1,3c2.7,0.7,5.5,1.4,8.2,2.2 c7.2,13.2,14.4,23.3,19.9,30.3c12.9,16.5,24.5,31.1,44.3,38.1c5.9,2.1,11,3,14.3,3.4c0-65.6,0-131.1,0-196.7 C130.2,79,109.7,79.8,89.2,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3mwl",
    d: "M244.4,153.8c-12.7-26-25.4-51.9-38.2-77.9c-18.5,0.7-37,1.5-55.5,2.2v196.7c2.9-0.1,7.1-0.5,12-1.8 c20.2-5.2,32.5-20,45.1-35.5c6.1-7.6,14.1-18.5,21.6-32.9c3.9-0.6,6.6-1.9,8.6-3.3C248.7,193.9,251.1,174.8,244.4,153.8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4mwl",
    d: "M62.4,223.9C74,181.1,85.5,138.4,97.1,95.6c6.8-4.7,25.2-15.9,51.3-16.2c27.1-0.2,46.2,11.6,53,16.2 c13.9,42.8,27.9,85.6,41.8,128.3c14.5-75.7-3-146-49.7-179.8c-9.8-7.1-23.9-14.8-43.5-19c-26.3,4.2-43.2,14.7-52.8,22.4 C53.7,82.3,40.2,152.2,62.4,223.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5mwl",
    d: "M67.7,184.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaceLogo);
export default __webpack_public_path__ + "static/media/mace-logo.cbd73a3f.svg";
export { ForwardRef as ReactComponent };